module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Au_Kanton_St._Gallen-80d7646d03d57944ca71708e336945bc.svg";